module.exports = __webpack_public_path__ + "static/media/bet-yellow-5.bdd937d9.png";